export default {
    text: {
        title: 'Text',
        addText: 'Ny text',
        fontFamily: 'Typsnittsfamilj',
        fontSize: 'Font size',
        textAlignment: 'Textjustering',
        fontColor: 'Textfärg',
        lineSpacing: 'Radavstånd',
        arialSerif: 'Arial (sans-serif)',
        verdanaSansSerif: ' Verdana (serifsfri)',
        tahomaSansSerif: 'Tahoma (sans-serif)',
        trebuchetMSSansSerif: 'Trebuchet MS (seriflöst)',
        timesNewRomanSerif: 'Times New Roman (seriferad)',
        georgiaSerif: ' Georgia (serif)',
        garamondSerif: 'Garamond (seriffer)',
        courierNewMonospace: 'Courier New (mellanslagsskrift)',
        brushScriptMTCursive: 'Pensel Skrift MT (kursiv)',
        backgroundColor: 'Bakgrundsfärg',
    },
};
